import React from 'react';
import logoImg from '../images/V2_DVF_Logo_Transparent_web.png';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__rule">
          <span className="footer__rule-line" />
          <span className="footer__rule-diamond" />
          <span className="footer__rule-line" />
        </div>
        <img src={logoImg} alt="DVF Logo" className="footer__logo" />
        <p className="footer__name">Dmitriy Filimonov</p>
        <p className="footer__copy">
          &copy; {new Date().getFullYear()} &nbsp;·&nbsp; Santa Clara, California
        </p>
      </div>
    </footer>
  );
}